var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-search"},[_c('div',{staticClass:"img-wrapper"},[_c('img',{attrs:{"src":"https://imgheybox.max-c.com/oa/2024/11/18/17b3fb9a2b560bfcb9d33dc0857b8f07.png"}})])])
}]

export { render, staticRenderFns }